import { LeadsBoardActions, LeadsBoardActionTypes } from '@crm/ngrx/actions/leads-board.actions';
import { CrmFilterService } from '@crm/services/crm-filter-service';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { TaskBoardRequest } from '@services/associations/model/taskBoardRequest';
import { TaskResponse } from '@services/associations/model/taskResponse';
import dayjs from "dayjs";

export function sortByScheduled(a: TaskResponse, b: TaskResponse) {
  if (a.time! > b.time!) {
    return 1;
  } else if (a.time! < b.time!) {
    return -1;
  } else {
    return 0;
  }
}

export const adapter: EntityAdapter<TaskResponse> = createEntityAdapter<TaskResponse>({
  sortComparer: sortByScheduled
});

export interface State extends EntityState<TaskResponse> {
  loading: boolean,
  filter: TaskBoardRequest,
}

export const initialState: State = adapter.getInitialState({
  loading: false,
  filter: {
    date: dayjs().format('YYYY-MM-DD'),
  },
});

export function reducer(state = initialState, action: LeadsBoardActions): State {
  switch (action.type) {
    /** Load Tasks */
    case LeadsBoardActionTypes.LoadTasks:
      return {...state, loading: !action.payload?.dontShowLoading};

    case LeadsBoardActionTypes.LoadTasksSuccess:
      return adapter.setAll(action.payload, {...state, loading: false});

    case LeadsBoardActionTypes.LoadTasksFailure:
      return  {...state, loading: false};

    /** Add Task */
    case LeadsBoardActionTypes.AddTasks:
      return {...state};

    case LeadsBoardActionTypes.AddTasksSuccess:
      if (CrmFilterService.checkFilterForReducers(state, action)) {
        return adapter.addOne(action.payload, {...state});
      } else {
        return {...state};
      }

    case LeadsBoardActionTypes.AddTasksFailure:
      return {...state};

    /** Edit Task */
    case LeadsBoardActionTypes.EditTasks:
      return {...state};

    case LeadsBoardActionTypes.EditTasksSuccess:
      return adapter.updateOne({
        id: action.payload.id!,
        changes: action.payload
      }, {...state});

    case LeadsBoardActionTypes.EditTasksFailure:
      return {...state};

    case LeadsBoardActionTypes.ChangeTaskStatusCanceled:
      return adapter.updateOne({
        id: action.payload.id!,
        changes: action.payload
      }, {...state});

    /** Edit Multiple Tasks */
    case LeadsBoardActionTypes.EditMultipleTasks:
      return adapter.updateMany(action.payload.map((task: TaskResponse) => Object.assign({}, {id: task.id!, changes: task})), {...state});

    /** Delete Task Success */
    case LeadsBoardActionTypes.DeleteTasksSuccess:
      return adapter.removeOne(action.payload, {...state});

    /** Set Filter */
    case LeadsBoardActionTypes.SetFilter:
      return {...state, filter: action.payload};

    case LeadsBoardActionTypes.UpdateFilter:
      return {...state, filter: {...state.filter, ...action.payload}};

    /** Clear Filter */
    case LeadsBoardActionTypes.ClearFilter:
      return {...state, filter: initialState.filter};

    /** Set Initial State */
    case LeadsBoardActionTypes.SetInitialState:
      return {...initialState};

    default:
      return state;
  }
}

export const {
  selectIds: selectTasksIds,
  selectEntities: selectTasksEntities,
  selectAll: selectAllTasks,
  selectTotal: selectTasksTotal,
} = adapter.getSelectors();
